import axiosInstance from '../../api/axios.js';
import type { OrganizationMember } from '../../admin/types.ts';

type OrgMemberApiItem = {
  id?: number;
  user_id?: number;
  username?: string;
  email?: string;
  first_name?: string;
  last_name?: string | null;
  is_active?: boolean;
  role?: string;
  is_default?: boolean;
};

function mapOrgAdminMembers(raw: OrgMemberApiItem[], organizationId: string): OrganizationMember[] {
  return raw.map((item) => ({
    id: item.id ?? item.user_id ?? 0,
    user_id: item.user_id ?? item.id ?? 0,
    organization_id: organizationId,
    role: item.role ?? 'report_viewer',
    is_default: Boolean(item.is_default),
    user: {
      id: item.id ?? item.user_id ?? 0,
      username: item.username ?? '',
      email: item.email ?? '',
      first_name: item.first_name ?? '',
      last_name: item.last_name ?? '',
      is_active: item.is_active == null ? undefined : Boolean(item.is_active),
    },
  }));
}

export async function fetchOrgAdminMembers(organizationId: string): Promise<OrganizationMember[]> {
  const { data } = await axiosInstance.get('/api/org-admin/members');
  const raw: OrgMemberApiItem[] = Array.isArray(data?.members) ? data.members : [];
  return mapOrgAdminMembers(raw, organizationId);
}

export async function updateOrgAdminMemberRole(userId: string, role: string): Promise<void> {
  await axiosInstance.patch(`/api/org-admin/members/${userId}/role`, { role });
}

export async function updateOrgAdminMemberEmail(userId: string, email: string): Promise<void> {
  await axiosInstance.patch(`/api/org-admin/members/${userId}/email`, { email });
}

export async function removeOrgAdminMember(userId: string): Promise<void> {
  await axiosInstance.delete(`/api/org-admin/members/${userId}`);
}
